import { FileItem } from '@models/file-item.model';
import { InvoiceUpdateInputPayload, LasgroInvoice, LasgroInvoice_line_item } from 'api/models';

export class InvoiceFile {
  created_at: Date;
  created_by: string;
  created_by_name: string;
  file_id: string;
  file_name: string;
  file_size: number;
  is_main_file: false;
  parent_uuid: string;
  uuid_type: string;

  constructor(data) {
    Object.assign(this, data);
  }
}

export class InvoiceLineItem implements LasgroInvoice_line_item {
  id: string;
  line_item_id: string;
  quantity_invoiced: number;
  quantity_ordered: number;
  product_name!: string;

  invoice_id: string;
  total_invoiced_to_date: number;
  total_ordered: number;
  constructor(data) {
    Object.assign(this, data);
  }
}

export class Invoice implements InvoiceUpdateInputPayload, LasgroInvoice {
  active: boolean;
  organization_id: string;
  created_at: string;
  created_by: string;
  created_by_name: string;
  customer_id: string;
  date: string;
  doc_number: string;
  id: string;
  line_items: InvoiceLineItem[];
  status: 'approved' | 'archived' | 'rejected' | 'pending';
  total_amount: number;
  updated_at: string;
  updated_by: string;
  rejection_reason: string;
  file: FileItem;
  description: string;

  constructor(data) {
    Object.assign(this, data);
  }
}
